import React, { PureComponent } from 'react';
import { Milex, WeatherEvent } from 'app/model/SOL49';
import { Flex } from 'app/components/common/Flex';
import { Card } from 'antd';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import TextArea from 'antd/es/input/TextArea';

export class MilexPanel extends PureComponent<{
    milexMap: { [key: string]: Milex };
    onChange: (milex: { [key: string]: Milex }) => void;
}> {
    private updateDescription = (id: string, text: string) => {
        const newMilexMap = Object.assign({}, this.props.milexMap);
        newMilexMap[id] = {
            edited: true,
            event: { ...this.props.milexMap[id].event, description: text },
        };
        this.props.onChange(newMilexMap);
    };

    render() {
        return (
            <Flex direction="vertical" className="milex">
                {Object.values(this.props.milexMap).map(({ event }) => (
                    <Card key={event.id} title={this.renderHeader(event)} style={{ backgroundColor: 'unset' }}>
                        <TextArea
                            rows={10}
                            value={event.description}
                            onChange={e => this.updateDescription(event.id, e.target.value)}
                        />
                    </Card>
                ))}
            </Flex>
        );
    }

    renderHeader = (event: WeatherEvent) => {
        return (
            <Flex direction={'vertical'}>
                <p className="title">{event.title}</p>
                <p className="location">{`Location: ${event.refLocs.map(refLoc => `${refLoc.refId}/${refLoc.refType}`).join(',')}`}</p>
                <p>{`Validity: ${TimePeriodUtils.formatDateHHMM(event.validity)}`}</p>
            </Flex>
        );
    };
}
